(() => {
  'use strict';

  const registerSearchPrompts = () => {
    if (!window.Alpine || typeof window.Alpine.data !== 'function') {
      return false;
    }

    window.Alpine.data('xSearchPrompts', (element, searchPrompts, enableOnMobile) => ({
      index: 0,
      indexMax: 2,
      diffIndex: [],
      diffStr: [],

      splitString(firstPrompt, secondPrompt) {
        const minLength = Math.min(firstPrompt.length, secondPrompt.length);
        let diffIndex = -1;
        let diffString = '';

        for (let index = 0; index < minLength; index += 1) {
          if (firstPrompt[index] !== secondPrompt[index]) {
            diffIndex = index;
            break;
          }
        }

        if (diffIndex === -1) {
          if (firstPrompt === secondPrompt) {
            diffIndex = secondPrompt.length - 1;
            diffString = secondPrompt[diffIndex];
          } else {
            diffIndex = minLength;
            diffString = secondPrompt.slice(diffIndex);
          }
        } else {
          diffString = secondPrompt.slice(diffIndex);
        }

        return { diffIndex, diffString };
      },

      async updatePlaceholder(input) {
        const wait = (delay) => new Promise((resolve) => window.setTimeout(resolve, delay));

        await wait(500);

        if (this.diffIndex[this.index] < input.placeholder.length - 1) {
          for (let index = input.placeholder.length - 1; index > this.diffIndex[this.index]; index -= 1) {
            input.placeholder = input.placeholder.slice(0, index - 1);
            await wait(80);
          }
        } else if (this.diffIndex[this.index] === input.placeholder.length - 1) {
          input.placeholder = input.placeholder.slice(0, this.diffIndex[this.index]);
          await wait(80);
        }

        await wait(800);

        for (const character of this.diffStr[this.index]) {
          input.placeholder += character;
          await wait(100);
        }

        this.index = this.index === this.indexMax ? 0 : this.index + 1;
        window.setTimeout(() => this.updatePlaceholder(input), 500);
      },

      init() {
        if (window.matchMedia('(max-width: 768px)').matches && !enableOnMobile) {
          return;
        }

        const prompts = searchPrompts.filter(Boolean);
        let pairs = [[0, 1], [1, 2], [2, 0]];

        if (!prompts.length) {
          return;
        }

        if (prompts.length === 1) {
          element.placeholder = prompts[0];
          return;
        }

        if (prompts.length === 2) {
          pairs = [[0, 1], [1, 0]];
          this.indexMax = 1;
        }

        element.placeholder = prompts[0];

        pairs.forEach(([firstIndex, secondIndex], index) => {
          const difference = this.splitString(prompts[firstIndex], prompts[secondIndex]);
          this.diffIndex[index] = difference.diffIndex;
          this.diffStr[index] = difference.diffString;
        });

        this.updatePlaceholder(element);
      },
    }));

    return true;
  };

  document.addEventListener('alpine:init', registerSearchPrompts, { once: true });

  if (window.Alpine) {
    registerSearchPrompts();
  }
})();
